import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
  use,
} from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import * as moment from "moment";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";
import { Alert, Tooltip } from "@mui/material";
//redux
import Flatpickr from "react-flatpickr";
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  getOrders as onGetOrders,
  changeOrderStatus as onChangeStatus,
  updateOrder as onUpdateOrder,
  purchaseOrder as onPurchaseOrder,
  cancelSupplierOrder as onCancelSupplierOrder,
  cancelCustomerOrder as onCancelCustomerOrder,
  orderShipped as onOrderShipped,
  getProductById as onGetProductById,
  offerUnits as onOfferUnits,
} from "../../slices/thunks";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createSelector } from "reselect";
import { orderStatus } from "../../Components/constants/layout";
import MovMet from "./movMetModal";
import Loader from "../../Components/Common/Loader";
import SupplierOrderDetail from "./OrderDetail";
import OrderDetail from "../CustomerOrders/OrderDetail";
import DebouncedInput from "../../Components/Common/DebouncedInput";
import ProductDetail from "../Products/ProductDetail";
import CancelModal from "./CancelModal";
import AlertModal from "../../Components/Common/AlertModal";

const Orders = () => {
  const dateFrom = useRef(null);
  const dateTo = useRef(null);
  const [modal, setModal] = useState(false);
  const [showCustomerDetails, setShowCustomerDetails] = useState(false);
  const [showProductDetail, setShowProductDetail] = useState(false);
  const [showOfferUnitsModal, setShowOfferUnitsModal] = useState({
    open: false,
    data: null,
  });
  const [activeTab, setActiveTab] = useState("1");
  const [firstLoad, setFirstLoad] = useState(true);
  const dispatch = useDispatch();

  const selectLayoutState = (state) => state;
  const selectOrderData = createSelector(selectLayoutState, (state) => ({
    orders: state.Orders.orders,
    pagination: state.Orders.pagination,
    orderPlaced: state.Orders.orderPlaced,
    orderCancelled: state.Orders.orderCancelled,
    loading: state.Orders.loading,
  }));
  const { orders, pagination, orderPlaced, orderCancelled, loading } =
    useSelector(selectOrderData);

  const selectProductData = createSelector(
    (state) => state.Products,
    (product) => product
  );
  // Inside your component
  const { product } = useSelector(selectProductData);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState([]);
  const [orderType, setOrderType] = useState("");
  const [customerOrder, setCustomerOrder] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState("all");

  const [movOrders, setMovOrders] = useState([]);
  const [showSendOrder, setShowSendOrder] = useState(false);
  const [showMoqAlert, setShowMoqAlert] = useState(false);
  const [showPlaceOrder, setShowPlaceOrder] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [showCancelOrder, setShowCancelOrder] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [updatedOrder, setUpdatedOrder] = useState(null);

  useEffect(() => {
    if (orders) {
      setOrderList(orders);
      setFirstLoad(false);
    }
  }, [orders]);

  useEffect(() => {
    if (orderPlaced) {
      getOrders();
      setShowPlaceOrder(false);
      setShowOrderDetail(false);
    }
  }, [orderPlaced]);

  useEffect(() => {
    if (orderCancelled === true) {
      getOrders();
      setShowOrderDetail(false);
      setShowCancelOrder(false);
    }
  }, [orderCancelled]);

  useEffect(() => {
    if (!firstLoad) {
      const data = {
        page: 0,
        total_rows: pagination ? pagination?.pageSize : 50,
        searchText: searchText,
        sort_by: "suo_dateCreated",
        statuses: null,
        status: null,
        dateFrom: dateFrom.current,
        dateTo: dateTo.current,
      };
      switch (Number(activeTab)) {
        case 2:
          data.status = 4;
          break;
        case 3:
          const stat = [];
          stat.push("MOV Met");
          stat.push("MOQ Met");
          data.statuses = stat.join(",");
          break;
        case 4:
          data.status = 5;
          break;
      }
      dispatch(onGetOrders(data));
    }
  }, [searchText]);

  useEffect(() => {
    switch (selectedPeriod) {
      case "7 days":
        const date = new Date();
        const sevenDaysAgo = new Date(date);
        sevenDaysAgo.setDate(date.getDate() - 7);
        dateFrom.current = sevenDaysAgo;
        dateTo.current = new Date();
        break;
      case "30 days":
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(new Date().getDate() - 30);
        dateFrom.current = thirtyDaysAgo;
        dateTo.current = new Date();
        break;
      case "all":
        dateFrom.current = null;
        dateTo.current = null;
        break;
      case "custom":
        dateFrom.current = null;
        dateTo.current = null;
        break;
      default:
        dateFrom.current = null;
        dateTo.current = null;
        break;
    }
    getOrders(null, pagination?.pageSize);
  }, [selectedPeriod]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      //let filteredOrders = orders;
      const data = {
        page: 0,
        total_rows: pagination?.pageSize,
        searchText: searchText,
        sort_by: "suo_dateCreated",
        statuses: null,
        status: null,
        dateFrom:
          dateFrom.current != null
            ? moment(dateFrom.current).format("YYYY-MM-DD")
            : null,
        dateTo:
          dateTo.current != null
            ? moment(dateTo.current).format("YYYY-MM-DD")
            : null,
      };
      console.log("type", type);

      switch (type) {
        case "Ordered":
          data.status = 4;
          break;
        case "Cancelled":
          data.status = 5;
          break;
        case "MOQ Met":
          const stat = [];
          stat.push("MOV Met");
          stat.push("MOQ Met");
          data.statuses = stat.join(",");
          break;
        case "Waiting MOQ":
          const stat1 = [];
          stat1.push("Waiting for MOV");
          stat1.push("Waiting for MOQ");
          data.statuses = stat1.join(",");
          break;
      }
      dispatch(onGetOrders(data));
      //setOrderList(filteredOrders);
    }
  };

  const getOrders = (page, pageSize) => {
    const data = {
      page: page ? page : 0,
      total_rows: pageSize ? pageSize : pagination ? pagination?.pageSize : 50,
      searchText: searchText,
      sort_by: "suo_dateCreated",
      statuses: null,
      status: null,
      dateFrom:
        dateFrom.current != null
          ? moment(dateFrom.current).format("YYYY-MM-DD")
          : null,
      dateTo:
        dateTo.current != null
          ? moment(dateTo.current).format("YYYY-MM-DD")
          : null,
    };
    switch (Number(activeTab)) {
      case 2:
        data.status = 4;
        break;
      case 3:
        const stat = [];
        stat.push("MOV Met");
        stat.push("MOQ Met");
        data.status = null;
        data.statuses = stat.join(",");
        break;
      case 4:
        data.status = 5;
        break;
    }
    dispatch(onGetOrders(data));
  };

  const onClickSendOrder = (order) => {
    setUpdatedOrder(order);
    setShowSendOrder(true);
  };

  const purchaseOrder = useCallback((orderIds) => {
    const data = {
      suo_id: orderIds,
    };
    dispatch(onPurchaseOrder(data));
  }, []);

  const onClickPlaceOrder = (order) => {
    {
      order.statusText === "MOV Met"
        ? setMovOrders(
            orderList.filter(
              (o) => o.suoSupId == order.suoSupId && o.statusText === "MOV Met"
            )
          )
        : purchaseOrder([order.suoId]);
    }
  };

  const onClickCancelOrder = (order, type) => {
    setShowCancelOrder(true);
    setOrderType(type);
    if (type === "customer") {
      setCustomerOrder(order);
    } else {
      setSelectedOrder(order);
    }
  };

  const onClickSetMoqMet = (order) => {
    setUpdatedOrder(order);
    setShowMoqAlert(true);
  };

  const shipToWarehouse = (orders) => {
    const data = {
      suo_id: orders.suoId,
    };
    dispatch(onOrderShipped(data));
  };

  const cancelOrder = (order, reason, otherReason, message, outOfStock) => {
    if (orderType === "customer") {
      const data = {
        ord_id: order.ord_id,
        cancellation_reason: reason,
        cancellation_message: message,
        cancellation_reason_text: otherReason,
        set_out_of_stock: outOfStock,
      };
      dispatch(onCancelCustomerOrder(data));
    } else {
      const data = {
        suo_id: order.suoId,
        cancellation_reason: reason,
        cancellation_message: message,
        cancellation_reason_text: otherReason,
        set_out_of_stock: outOfStock,
      };
      dispatch(onCancelSupplierOrder(data));
    }
  };

  useEffect(() => {
    if (movOrders.length > 0) setShowPlaceOrder(true);
  }, [movOrders]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
      setDate(defaultdate());
    }
  }, [modal]);

  const handleOrderClicks = () => {
    setOrder("");
    //setIsEdit(false);
    toggle();
  };

  const handleOrderClick = useCallback(
    (order) => {
      //console.log("handleOrderClick", order);
      setSelectedOrder(order);
      //setMovOrders(order);
      setShowOrderDetail(true);
      toggle();
    },
    [toggle]
  );

  // Node API
  // useEffect(() => {
  //   if (isOrderCreated) {
  //     setOrder(null);
  //     dispatch(onGetOrders());
  //   }
  // }, [
  //   dispatch,
  //   isOrderCreated,
  // ]);

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".orderCheckBox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteMultiple = () => {
    const checkall = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element) => {
      // dispatch(onDeleteOrder(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".orderCheckBox:checked");
    ele.length > 0
      ? setIsMultiDeleteButton(true)
      : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  const offerUnits = (orders) => {
    orders.forEach((element) => {
      const data = {
        ord_id: element.ordId,
      };
      dispatch(onOfferUnits(data));
    });
    setShowOfferUnitsModal({ open: false, data: null });
  };

  // Column
  const columns = useMemo(
    () => [
      {
        header: " ",
        accessorKey: "suoId",
        enableColumnFilter: false,
        cell: (info) => {
          return (
            <>
              {info.row.getCanExpand() && (
                <button
                  onClick={info.row.getToggleExpandedHandler()}
                  className="btn-round btn btn-outline-primary btn-sm"
                >
                  {info.row.getIsExpanded() ? "-" : "+"}
                </button>
              )}
            </>
          );
        },
      },
      {
        header: "Order #",
        accessorKey: "suoId",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <Link
              to="#"
              className="text-primary fw-semibold"
              onClick={() => handleOrderClick(cell.row.original)}
            >
              {cell.getValue()}
            </Link>
          );
        },
      },
      {
        header: "Product",
        accessorKey: "productName",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <div className="flex-grow-1">
              <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                <Link
                  onClick={() => {
                    const data = {
                      pro_id: cell.row.original.suoProId,
                    };
                    dispatch(onGetProductById(data));
                    setShowProductDetail(true);
                  }}
                >
                  {" "}
                  {cell.getValue()}
                </Link>
              </div>
              {cell.row.original.productPackQuantity > 1 && (
                <span className="badge rounded-pill bg-primary text-dark">
                  pack of {cell.row.original.productPackQuantity}
                </span>
              )}
            </div>
          );
        },
      },
      {
        header: "Product codes",
        accessorKey: "productUPC",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span>
              <b>UPC:</b> {cell.getValue() || "N/A"}
              {cell.row.original.productASIN && (
                <span> / <b>ASIN:</b> {cell.row.original.productASIN}</span>
              )}
              {cell.row.original.productSKU && (
                <span> / <b>SKU:</b> {cell.row.original.productSKU}</span>
              )}
            </span>
          );
        },
      },
      {
        header: "Supplier",
        accessorKey: "supplierName",
        enableColumnFilter: false,
      },
      {
        header: "Time Left",
        accessorKey: "suoTimeLeft",
        enableColumnFilter: false,
        cell: (cell) => {
          if (
            cell.row.original.suoStatus == orderStatus.STATUS_ORDERED ||
            cell.row.original.suoStatus == orderStatus.STATUS_CANCELLED ||
            cell.row.original.suoStatus == orderStatus.STATUS_EXPIRED ||
            cell.row.original.suoStatus == orderStatus.STATUS_SHIPPED
          ) {
            return (
              <span
                className={`badge  text-dark ${cell.row.original.suoStatus == orderStatus.STATUS_CANCELLED ? "bg-danger" : "bg-success"}`}
                style={{ width: "100px" }}
              >
                N/A
              </span>
            );
          }
          if (cell.getValue() === "Time elapsed") {
            return (
              <span
                className="badge text-dark"
                style={{ backgroundColor: "#936BED", width: "100px" }}
              >
                Time elapsed
              </span>
            );
          } else {
            const days = cell.getValue().substring(0, 1);
            let className = "badge  text-dark bg-success";
            if (days < 2) {
              className = "badge text-dark bg-danger";
            } else if (days < 3) {
              className = "badge  text-dark bg-warning";
            }
            return (
              <span className={className} style={{ width: "100px" }}>
                {cell.getValue()}
              </span>
            );
          }
          /*
          const cellValue = cell.getValue();
          const dateWith7DaysAdded = moment(cellValue).add(7, "days");
          const now = moment().utc().subtract(5, 'hours');
          const diffDuration = moment.duration(dateWith7DaysAdded.diff(now));

          const days = diffDuration.days();
          const hours = diffDuration.hours();
          const minutes = diffDuration.minutes();

          if (days < 0 || hours < 0 || minutes < 0) {
            return (
              <span
                className="badge text-dark"
                style={{ backgroundColor: "#936BED", width: "100px" }}
              >
                Time elapsed
              </span>
            );
          }
          let className = "badge  text-dark bg-success";
          if (days < 2) {
            className = "badge text-dark bg-danger";
          } else if (days < 3) {
            className = "badge  text-dark bg-warning";
          }
          return (
            <span className={className} style={{ width: "100px" }}>
              {days}d {hours}h {minutes}m
            </span>
          );
          */
        },
      },
      {
        header: "MOQ",
        accessorKey: "suoMOQ",
        enableColumnFilter: false,
      },
      {
        header: "Price",
        accessorKey: "suoTotalPrice",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            <span className="fw-semibold">
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(cell.getValue())}
            </span>
          </>
        ),
      },
      {
        header: "Order Date",
        accessorKey: "suoDateCreated",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {moment(cell.getValue()).format("MM/DD/YYYY")}
            <br />
            <small className="text-muted">
              {moment(cell.getValue()).format("hh:mm A")}
            </small>
          </>
        ),
      },
      {
        header: "Status",
        accessorKey: "suoStatus",
        enableColumnFilter: false,
        cell: (cell) => {
          if (cell.row.original.ord_cancellationReason)
            return (
              <span
                style={{ width: "100px" }}
                className="badge text-uppercase text-dark bg-danger "
              >
                Cancelled
              </span>
            );

          if (Number(cell.getValue()) == orderStatus.STATUS_ACTIVE) {
            switch (cell.row.original.statusText) {
              case "Waiting for MOQ":
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-warning"
                  >
                    {" "}
                    {cell.row.original.statusText}{" "}
                  </span>
                );
              case "Waiting for MOV":
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-warning"
                  >
                    {" "}
                    {cell.row.original.statusText}{" "}
                  </span>
                );
              case "Cancelled":
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-danger"
                  >
                    {" "}
                    {cell.row.original.statusText}{" "}
                  </span>
                );
              case "MOV Met":
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-success"
                  >
                    {" "}
                    {cell.row.original.statusText}{" "}
                  </span>
                );
              case "MOQ Met":
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-success"
                  >
                    {" "}
                    {cell.row.original.statusText}{" "}
                  </span>
                );
              default:
                return <span></span>;
            }
          } else {
            switch (cell.getValue()) {
              case orderStatus.STATUS_ORDERED:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-success"
                  >
                    ordered
                  </span>
                );
              case orderStatus.STATUS_CANCELLED:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-danger"
                  >
                    cancelled
                  </span>
                );
              case orderStatus.STATUS_EXPIRED:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-warning"
                  >
                    {" "}
                    EXPIRED
                  </span>
                );
              case orderStatus.STATUS_SHIPPED:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-success"
                  >
                    SHIPPED
                  </span>
                );
              case orderStatus.STATUS_MOV_MET:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-success"
                  >
                    MOQ Met
                  </span>
                );
              case orderStatus.STATUS_MOQ_MET:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-success"
                  >
                    MOQ Met
                  </span>
                );
              case orderStatus.STATUS_MOQNOTMET:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-danger"
                  >
                    MOQ Not Met
                  </span>
                );
              case orderStatus.STATUS_MOVNOTMET:
                return (
                  <span
                    style={{ width: "100px" }}
                    className="badge text-uppercase text-dark bg-danger"
                  >
                    MOV Not Met
                  </span>
                );
              default:
                return <span></span>;
            }
          }
        },
      },
      {
        header: "Action",
        cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
                <Tooltip title="View Details">
                  <Link
                    to="#"
                    className="text-primary d-inline-block"
                    onClick={() => handleOrderClick(cellProps?.row.original)}
                  >
                    <i className="ri-eye-fill fs-16"></i>
                  </Link>
                </Tooltip>
              </li>

              {(cellProps?.row.original.statusText === "MOQ Met" ||
                cellProps?.row.original.statusText === "MOV Met" ||
                cellProps?.row.original.suoStatus ===
                  orderStatus.STATUS_MOQ_MET ||
                cellProps?.row.original.suoStatus ===
                  orderStatus.STATUS_MOV_MET) && (
                <li className="list-inline-item">
                  <Tooltip title="Send Order">
                    <button
                      className="text-success border-0 bg-transparent p-0"
                      onClick={() => onClickSendOrder(cellProps.row.original)}
                    >
                      <i className="ri-send-plane-fill fs-16"></i>
                    </button>
                  </Tooltip>
                </li>
              )}
              {(cellProps?.row.original.statusText === "MOQ Met" ||
                cellProps?.row.original.statusText === "MOV Met" ||
                cellProps?.row.original.suoStatus ===
                  orderStatus.STATUS_MOQ_MET ||
                cellProps?.row.original.suoStatus ===
                  orderStatus.STATUS_MOV_MET ||
                cellProps?.row.original.statusText === "Waiting for MOV" ||
                cellProps?.row.original.statusText === "Waiting for MOQ") && (
                <li className="list-inline-item">
                  <Tooltip title="Cancel Order">
                    <button
                      className="text-danger border-0 bg-transparent p-0"
                      onClick={() =>
                        onClickCancelOrder(cellProps?.row.original, "supplier")
                      }
                    >
                      <i className="ri-close-circle-fill fs-16"></i>
                    </button>
                  </Tooltip>
                </li>
              )}
              {cellProps?.row.original.statusText === "Waiting for MOV" && (
                <li className="list-inline-item">
                  <Tooltip title="Set MOQ Met">
                    <button
                      className="text-success border-0 bg-transparent p-0"
                      onClick={() => {
                        onClickSetMoqMet(cellProps?.row.original);
                      }}
                    >
                      <i className="ri-check-line fs-18"></i>
                    </button>
                  </Tooltip>
                </li>
              )}
              {cellProps?.row.original.statusText === "Waiting for MOQ" && (
                <li className="list-inline-item">
                  <Tooltip title="Set MOQ Met">
                    <button
                      className="text-success border-0 bg-transparent p-0"
                      onClick={() => {
                        onClickSetMoqMet(cellProps?.row.original.suoId);
                      }}
                    >
                      <i className="ri-check-line fs-18"></i>
                    </button>
                  </Tooltip>
                </li>
              )}
              {cellProps?.row.original.statusText === "Waiting for MOQ" && (
                <li className="list-inline-item">
                  <Tooltip title="Offer More Units">
                    <button
                      className="text-primary border-0 bg-transparent p-0"
                      onClick={() => {
                        setShowOfferUnitsModal({
                          open: true,
                          data: cellProps?.row.original.orders,
                        });
                      }}
                    >
                      <i className="ri-mail-line  fs-16"></i>
                    </button>
                  </Tooltip>
                </li>
              )}

              {cellProps?.row.original.statusText === "" &&
                cellProps?.row.original.suoStatus != 5 &&
                cellProps?.row.original.suoStatus != 7 &&
                cellProps?.row.original.suoStatus !=
                  orderStatus.STATUS_MOQ_MET &&
                cellProps?.row.original.suoStatus !=
                  orderStatus.STATUS_MOV_MET && (
                  <li className="list-inline-item">
                    <Tooltip title="Ship to warehouse">
                      <button
                        className="text-success border-0 bg-transparent p-0"
                        onClick={() => {
                          shipToWarehouse(cellProps?.row.original);
                        }}
                      >
                        <i className="ri-truck-fill align-middle me-1"></i>{" "}
                      </button>
                    </Tooltip>
                  </li>
                )}
            </ul>
          );
        },
      },
    ],
    [handleOrderClick, checkedAll]
  );

  const defaultdate = () => {
    let d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    let h = d.getHours() % 12 || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return (
      d.getDate() +
      " " +
      months[d.getMonth()] +
      ", " +
      d.getFullYear() +
      ", " +
      h +
      ":" +
      d.getMinutes() +
      " " +
      ampm
    ).toString();
  };

  const [date, setDate] = useState(defaultdate());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");

    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = H % 12 || 12;
    h = h <= 9 ? (h = "0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  };

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const [isExportCSV, setIsExportCSV] = useState(false);

  document.title = "Orders | Buyers Club";
  return (
    <div className="page-content">
      <AlertModal
        text="An email will be sent to each order, offering more units to the associated customers. Are you sure you want to offer more units?"
        onNoClick={() => setShowOfferUnitsModal({ open: false, data: null })}
        show={showOfferUnitsModal.open}
        onYesClick={() => {
          offerUnits(showOfferUnitsModal.data);
        }}
      />
      <AlertModal
        text="Are you sure you want to set MOQ Met"
        onNoClick={() => setShowMoqAlert(false)}
        show={showMoqAlert}
        onYesClick={() => {
          //  console.log("updatedOrder", updatedOrder);
          const order = {
            suo_id: updatedOrder,
            status: orderStatus.STATUS_MOQ_MET,
          };
          dispatch(onChangeStatus(order));
          setShowMoqAlert(false);
        }}
      />
      <AlertModal
        text="Are you sure you want to send the order?"
        onNoClick={() => setShowSendOrder(false)}
        show={showSendOrder}
        onYesClick={() => {
          const data = {
            suo_id: [updatedOrder.suoId],
          };
          dispatch(onPurchaseOrder(data));
          setShowSendOrder(false);
        }}
      />
      <ProductDetail
        product={product}
        show={showProductDetail}
        onClose={() => setShowProductDetail(false)}
      />
      <MovMet
        show={showPlaceOrder}
        onCloseClick={() => setShowPlaceOrder(false)}
        onSendClick={(orders) => purchaseOrder(orders.map((o) => o.suoId))}
        orders={movOrders}
      />
      <SupplierOrderDetail
        show={showOrderDetail}
        onCloseClick={() => setShowOrderDetail(false)}
        orders={selectedOrder}
        onCancelClick={(order) => onClickCancelOrder(order, "supplier")}
        onSendClick={(orders) => onClickPlaceOrder(orders)}
        onShipToWarehouseClick={(orders) => shipToWarehouse(orders)}
        onSetMOQClick={(orders) => {
          const order = {
            suo_id: orders.suoId,
            status: orderStatus.STATUS_MOQ_MET,
          };
          dispatch(onChangeStatus(order));
        }}
        onSetMOVClick={(orders) => {
          const order = {
            suo_id: orders.suoId,
            status: orderStatus.STATUS_MOV_MET,
          };
          dispatch(onChangeStatus(order));
        }}
      />
      <OrderDetail
        show={showCustomerDetails}
        onCloseClick={() => setShowCustomerDetails(false)}
        orders={customerOrder}
        onSendClick={(orders) => console.log(orders)}
        onCancelClick={(order) => onClickCancelOrder(order, "customer")}
        onShipToWarehouseClick={(orders) => shipToWarehouse(orders)}
        onRefoundClick={(order, quantity) => {
          const data = {
            order: {
              ord_id: order.ord_id,
              ord_user_id: order.ord_user_id,
              ord_suo_id: order.ord_suo_id,
              ord_pro_id: order.ord_pro_id,
              ord_sup_id: order.ord_sup_id,
              ord_quantity: Number(quantity),
              ord_totalPrice: order.ord_totalPrice,
              ord_dateCreated: order.ord_dateCreated,
              ord_datePurchaseOrder: order.ord_datePurchaseOrder,
              ord_status: order.ord_status,
            },
            update_moq: false,
          };
          /*
          const data = {
            order: {
              ord_id: order.ordId,
              ord_user_id: order.ordUserId,
              ord_suo_id: order.ordSuoId,
              ord_pro_id: order.ordProId,
              ord_sup_id: order.ordSupId,
              ord_quantity: quantity,
              ord_totalPrice: order.ordTotalPrice,
              ord_paymentIntentId: order.ordPaymentIntentId,
              ord_dateCreated: order.ordDateCreated,
              ord_datePurchaseOrder: order.ordDatePurchaseOrder,
              ord_status: order.ordStatus,
            },
            update_moq: false,
          };
          */
          dispatch(onUpdateOrder(data));
        }}
      />
      <CancelModal
        show={showCancelOrder}
        onCancelClick={(orderId, reason, otherReason, message, outOfStock) =>
          cancelOrder(orderId, reason, otherReason, message, outOfStock)
        }
        onCloseClick={() => setShowCancelOrder(false)}
        order={orderType === "supplier" ? selectedOrder : customerOrder}
        type={orderType}
      />

      <Container fluid>
        <BreadCrumb title="Supplier Orders" pageTitle="Orders" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0 align-items-center d-flex">
                <h5 className="card-title mb-0 flex-grow-1">Orders History</h5>

                <div className="d-flex gap-1">
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "all" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("all");
                    }}
                  >
                    ALL
                  </button>
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "7 days" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("7 days");
                    }}
                  >
                    7 Days
                  </button>
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "30 days" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("30 days");
                    }}
                  >
                    30 Days
                  </button>
                  <button
                    type="button"
                    className={`btn btn-soft-${
                      selectedPeriod === "custom" ? "success" : "secondary"
                    } btn-sm shadow-none`}
                    onClick={() => {
                      setSelectedPeriod("custom");
                    }}
                  >
                    Custom
                  </button>
                  {selectedPeriod === "custom" && (
                    <div className="d-flex align-items-center gap-2 mt-2">
                      <Flatpickr
                        className="form-control"
                        id="datepicker-publish-input"
                        placeholder="Select a date from"
                        onChange={(selectedDates, dateStr, instance) => {
                          dateFrom.current = selectedDates[0];
                          getOrders(null, pagination?.pageSize);
                        }}
                        options={{
                          maxDate: dateTo.current,
                          mode: "single",
                          dateFormat: "m-d-Y",
                        }}
                      />
                      <span>to</span>
                      <Flatpickr
                        className="form-control"
                        id="datepicker-publish-input"
                        placeholder="Select a date to"
                        onChange={(selectedDates, dateStr, instance) => {
                          dateTo.current = selectedDates[0];
                          getOrders(null, pagination?.pageSize);
                        }}
                        options={{
                          mode: "single",
                          minDate: dateFrom.current,
                          dateFormat: "m-d-Y",
                        }}
                      />
                    </div>
                  )}
                </div>
              </CardHeader>

              <CardBody className="pt-0">
                <div>
                  <div className="card-header border-0">
                    <div className="row align-items-center">
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "1" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "all");
                            }}
                            href="#"
                          >
                            All Orders
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.total}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "Ordered");
                            }}
                            href="#"
                          >
                            Ordered
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalOrdered}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "MOQ Met");
                            }}
                            href="#"
                          >
                            MOQ Met
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalReady}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "4" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("4", "Cancelled");
                            }}
                            href="#"
                          >
                            Cancelled
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalCancelled}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "5" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("5", "Waiting MOQ");
                            }}
                            href="#"
                          >
                            Waiting MOQ
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination?.totalWaiting}
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </div>
                  <CardBody className="border border-dashed border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={5}>
                          <div className="search-box me-2 mb-2 d-inline-block">
                            <DebouncedInput
                              value={searchText ?? ""}
                              onChange={(value) => setSearchText(value)}
                              placeholder="Search orders"
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                  <div className="card-body pt-0">
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={orderList || []}
                        customPageSize={50}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle"
                        theadClass="table-light text-dark text-uppercase"
                        handleOrderClick={handleOrderClicks}
                        SearchPlaceholder="Search orders..."
                        pagination={pagination}
                        manualPagination={true}
                        onPreviousPage={() => {
                          getOrders(
                            pagination.currentPage - 1,
                            pagination.pageSize
                          );
                        }}
                        onNextPage={() => {
                          getOrders(
                            pagination.currentPage + 1,
                            pagination.pageSize
                          );
                        }}
                        onGetPage={(page, pageSize) => {
                          getOrders(page, pageSize);
                        }}
                        onSearch={(value) => {
                          setSearchText(value);
                        }}
                        onCustomerOrderClick={(order) => {
                          setCustomerOrder(order);
                          setShowCustomerDetails(true);
                        }}
                        onCustomerCancelClick={(order) =>
                          onClickCancelOrder(order, "customer")
                        }
                      />
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Orders;
